import { render, staticRenderFns } from "./aranceles.vue?vue&type=template&id=33c614e2&scoped=true"
import script from "./aranceles.vue?vue&type=script&lang=js"
export * from "./aranceles.vue?vue&type=script&lang=js"
import style0 from "./aranceles.vue?vue&type=style&index=0&id=33c614e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c614e2",
  null
  
)

export default component.exports